// src/components/home/Inicio.jsx
import {
  Alert,
  AppBar,
  Box,
  Button,
  CardMedia,
  Modal,
  Snackbar,
  Stack,
  Toolbar,
  Typography,
  Tooltip,
  ButtonBase,
  Grid,
  Container as MuiContainer,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useFetch } from '../../hook/useFetch';
import { rutas } from '../../rutas/rutas';

import tierra1 from '../../Web Mundo/GIF-ISLA-1HS_yzyprs_1_pnzh53.gif';
import tierra2 from '../../Web Mundo/TIERRA-HUESO-GIF_vcj73t_ji8wkf.gif';
import tierra3 from '../../Web Mundo/ISLA-ENERGIA_x5cvlq_ojo9ia.gif';
import tierra4 from '../../Web Mundo/swap.gif';
import tierra5 from '../../Web Mundo/tierra5.gif';

import { Cronometro } from '../cronometro/Cronometro';
import { useDispatch, useSelector } from 'react-redux';
import { setInformacion } from '../../storage/slices/usuarios';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../../utils/getCookie';
import axios from 'axios';
import { Container } from '@mui/system';
import { ModalPool } from './ModalPool';
import { Hueso } from '../ecosistema/Hueso';
import dayjs from 'dayjs';
import { keyframes } from '@mui/system';
import EntryOverlay from '../overlay/EntryOverlay';
import PetOverlay from '../PetOverlay/PetOverlay';


/* ---------------- Modal base style ---------------- */
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 350, sm: 500, md: 1000 },
  height: { xs: '80%', md: '70%' },
  overflow: 'auto',
  boxShadow: 24,
  p: 2,
};



// (arriba, junto a otros const)
const BURN_PATH = "/game/album?page=6";
const ARENA_PATH = "/game/arena";
const RANKING_PATH = "/game/album?page=7";



/* Alturas de cada bloque (sin “cuadrado” visual) para alinear botones */
const BLOCK_MIN_HEIGHT = { xs: 300, sm: 320, md: 360 };
const IMG_HEIGHT = { xs: 170, sm: 190, md: 210 };

/* Estilo común de imágenes: pegadas abajo (GIFs con transparente) */
const ISLAND_IMG_SX = {
  width: '100%',
  height: IMG_HEIGHT,
  objectFit: 'contain',
  objectPosition: 'center bottom',
  display: 'block',
  userSelect: 'none',
  pointerEvents: 'none',
};

/* =========================
   METRICS BUTTON (English + 🔥 Burned)
   ========================= */
const API_BASE_METRICS = 'https://bigdogbonegame.com';







const MetricsHuesoButton = ({ user = '' }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [day, setDay] = React.useState(0);
  const [week, setWeek] = React.useState(0);
  const [month, setMonth] = React.useState(0);
  const [burned, setBurned] = React.useState(0);

  const fetchMetrics = async () => {
    try {
      setLoading(true);
      const url = user
        ? `${API_BASE_METRICS}/metrics/hueso?user=${encodeURIComponent(user)}`
        : `${API_BASE_METRICS}/metrics/hueso`;
      const res = await fetch(url, { method: 'GET' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const j = await res.json();

      const last = (arr) => (arr?.length ? arr[arr.length - 1]?.total || 0 : 0);
      setDay(last(j?.dia));
      setWeek(last(j?.semana));
      setMonth(last(j?.mes));
      setBurned(Number(j?.quemado || 0));
    } catch (e) {
      console.error('[metrics/hueso] fetch error:', e?.message);
      setDay(0); setWeek(0); setMonth(0); setBurned(0);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { if (open) fetchMetrics(); }, [open]);

  const fmt = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 8 });

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          cursor: 'pointer',
          bgcolor: 'rgba(0,0,0,0.6)',
          borderRadius: 2,
          p: 0.5,
          mb: 1,
          display: 'flex',
          justifyContent: 'center',
          transition: 'transform 120ms ease, opacity 120ms ease',
          '&:hover': { transform: 'translateY(-1px)', opacity: 0.95 },
        }}
        aria-label="Open HUESO metrics"
        title="HUESO metrics"
      >
        <CardMedia
          component="img"
          src="https://www.bigdogbonegame.com/static/media/barril-animado.67bade929e092f18cf89.gif"
          alt="Hueso Metrics"
          sx={{ width: 42, height: 42, display: 'block' }}
          loading="lazy"
        />
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'rgba(20,20,20,0.98)',
            color: 'white',
            borderRadius: 3,
            p: 3,
            width: 340,
            textAlign: 'center',
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 800 }}>
            🦴✨ Total Hueso Mined from the Lands
          </Typography>

          <Typography variant="body2" sx={{ mb: 0.5 }}>🌞 Day: <b>{loading ? '…' : fmt(day)}</b></Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>🗓️ Week: <b>{loading ? '…' : fmt(week)}</b></Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>🚀 Month: <b>{loading ? '…' : fmt(month)}</b></Typography>

          <Box sx={{ mt: 1.5, p: 1, borderRadius: 2, bgcolor: 'rgba(255,69,0,0.12)', border: '1px solid rgba(255,69,0,0.35)' }}>
            <Typography variant="body2">🔥 <b>Burned:</b> {loading ? '…' : fmt(burned)}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>(manual total from admin)</Typography>
          </Box>

          <Button variant="contained" sx={{ mt: 2 }} onClick={fetchMetrics} disabled={loading}>🔄 Refresh</Button>
        

        
        </Box>
      </Modal>
    </>
  );
};

export const Inicio = () => {
  const [peticion] = useFetch();
  const { informacion } = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();
  const [open2, setOpen2] = React.useState(false);
  const handleClose2 = () => setOpen2(false);
  const [open, setOpen] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClose3 = () => setOpen3(false);
  const [error, setError] = React.useState(false);
  const [timeServer, setTimeServer] = React.useState('');
  const navigate = useNavigate();
  const [mensaje, setMensaje] = React.useState({
  texto: '',
  linkUrl: '',
  linkLabel: '',
});

  const [control, setControl] = React.useState(false);
  const [open9, setOpen9] = React.useState(false);
  const [errorText, setErrorText] = React.useState('Error');



  // ===== Entry Overlay (always show) =====
const [showEntryOverlay, setShowEntryOverlay] = React.useState(false);

useEffect(() => {
  setShowEntryOverlay(true); // aparece en cada refresh
}, []);

const closeEntryOverlay = React.useCallback(() => setShowEntryOverlay(false), []);



  const pulse = keyframes`
    0%   { transform: scale(1); }
    50%  { transform: scale(1.08); }
    100% { transform: scale(1); }
  `;

  const gameLogos = [
    { name: 'City Farm web game', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052377/logos/logo_xyjkop.png', type: 'external', href: 'https://cityfarmgame.com/' },
    { name: 'Bot Game Nova La exploradora', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052358/logos/logo_nova_hv5mrd.png', type: 'external', href: 'https://discord.gg/ShA6MKRHz9' },
    { name: 'Bot Mundo Airdrops', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755052363/logos/mundoairdrops_s6mwyo.png', type: 'external', href: 'https://mundo-virtual.gitbook.io/mundo-bot-discord/' },
  ];

  const appsLogos = [
    { name: 'Market HiveNFts', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755319758/hivenfts-logo_sawbud.png', type: 'external', href: 'https://hivenfts.com/big-dog-bone/buy/' },
    { name: 'Buy or Sell Hueso', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755113326/7._hueso_1_astveu.png', type: 'external', href: 'https://tribaldex.com/swap?from=SWAP.HIVE&to=HUESO' },
    { name: 'Buy or Sell VipHueso', logo: 'https://res.cloudinary.com/dkm71aag8/image/upload/v1755113343/8._viph_bn9r8g.webp', type: 'external', href: 'https://tribaldex.com/swap?from=SWAP.HIVE&to=VIPHUESO' },
  ];

  const goToLogo = (item) => {
    if (item.type === 'internal' && item.to) navigate(item.to);
    else if (item.type === 'external' && item.href) window.open(item.href, '_blank', 'noopener,noreferrer');
  };

  const VerticalLogosRight = ({ items, sx: extraSx = {}, children }) => (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 96, sm: 120 },
        right: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: 1.2,
        zIndex: 1200,
        p: 1,
        borderRadius: 3,
        bgcolor: 'rgba(255,255,255,0.08)',
        backdropFilter: 'blur(4px)',
        boxShadow: 3,
        ...extraSx,
      }}
    >
      {children}
      {items.map((g, idx) => (
        <Tooltip key={g.name} title={g.name} arrow placement="left">
          <ButtonBase
            onClick={() => goToLogo(g)}
            sx={{
              borderRadius: 2,
              p: 0.5,
              transition: 'transform 120ms ease, opacity 120ms ease',
              '&:hover': { transform: 'translateX(-2px)', opacity: 0.9 },
            }}
            aria-label={`Ir a ${g.name}`}
          >
            <CardMedia
              component="img"
              image={g.logo}
              alt={g.name}
              loading="lazy"
              sx={{
                width: { xs: 42, sm: 54 },
                height: 'auto',
                display: 'block',
                borderRadius: 1.5,
                willChange: 'transform',
                transformOrigin: 'center',
                animation: `${pulse} 1.6s ease-in-out infinite`,
                animationDelay: `${idx * 0.12}s`,
                '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
              }}
            />
          </ButtonBase>
        </Tooltip>
      ))}
    </Box>
  );

  const comprar = () => navigate('/game/market', { replace: true });
  const handleClose9 = () => setOpen9(false);

  useEffect(() => { if (control) setOpen3(true); }, [control]);

  useEffect(() => {
    const tokenJWT = getCookie('token');
    
    axios
  .get(`${rutas.getInformacion}`, { headers: { token: tokenJWT } })
  .then((res) => {
    if (res.data?.resultado?.hora) setTimeServer(res.data?.resultado?.hora);

    if (res.data?.mensajes) {
      setMensaje(res.data.mensajes);  // 👈 aquí ahora es { texto, linkUrl, linkLabel }
    } else {
      setMensaje({ texto: '', linkUrl: '', linkLabel: '' });
    }

    setControl(true);
    //cambiar tiempo de durabilidad del mensaje
    setTimeout(() => setControl(false), 30000);
  });


  }, []);

 const buildPetMissionMessage = (tipo, resultado) => {
  const petBenefit = resultado?.petBenefit;
  const petApplied = resultado?.petApplied;

  let baseText = '';

  if (tipo === 4) baseText = '4-hour special mission started successfully';
  else if (tipo === 1) baseText = '1-hour mission started successfully';
  else if (tipo === 6) baseText = '6-hour mission started successfully';
  else if (tipo === 3) baseText = 'Energy recharge mission started successfully';
  else baseText = 'Mission started successfully';

  if (!petBenefit) {
    return baseText;
  }

  if (!petBenefit?.active) {
    return `${baseText}. Puppy bonus inactive. Keep your puppy healthy to activate bonuses.`;
  }

  const energy = petApplied?.energy;
  const time = petApplied?.time;

  const parts = [];

  if (energy?.energyBonusPercent > 0 && Number(energy?.savedEnergy || 0) > 0) {
    parts.push(
      `Energy bonus: ${energy.energyBonusPercent}% saved ${energy.savedEnergy} energy`
    );
  }

  if (
    tipo === 6 &&
    time?.walkTimeReductionPercent > 0 &&
    Number(time?.savedMinutes || 0) > 0
  ) {
    parts.push(
      `Walk reduction: ${time.walkTimeReductionPercent}% saved ${time.savedMinutes} minutes`
    );
  }

  if (!parts.length) {
    return `${baseText}. Puppy bonus active.`;
  }

  return `${baseText}. ${parts.join(' | ')}`;
};

const mision = async (tipo) => {
  try {
    if (tipo === 4 && !['mv-deposito', 'lavino'].includes(informacion?.nombre)) {
      setErrorText('It is not yet available, it will be soon.');
      setError(true);
      setOpen2(true);
      return;
    }

    const resultado = await peticion(rutas.mision, 'post', { mision: tipo });

    if (resultado) {
      dispatch(setInformacion(resultado?.usuario));
      setError(false);
      setErrorText(buildPetMissionMessage(tipo, resultado));
      setOpen2(true);
    }
  } catch (error) {
    setErrorText(
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      'Mission error'
    );
    setError(true);
    setOpen2(true);
  }
};

  const puedeReclamarEspecial = () => {
    if (!informacion?.misionEspecial?.start || !informacion?.misionEspecial?.Tiempo) return false;
    const ahora = dayjs();
    const tiempoFin = dayjs(informacion.misionEspecial.Tiempo);
    return ahora.isAfter(tiempoFin) || ahora.isSame(tiempoFin);
  };

  /* =========================
     ARENA CONFIG
     ========================= */
  const ARENA_ENERGY_COST = 5;
  const ARENA_ENTRY_FEE = 250;

  const energiaActual = Number(
    (informacion?.energia && typeof informacion.energia === 'object'
      ? informacion?.energia?.actual
      : informacion?.energia) ?? 0
  );
  const hasEnoughEnergyForArena = energiaActual >= ARENA_ENERGY_COST;
  const missionActive = Boolean(informacion?.mision?.start || informacion?.misionEspecial?.start);
 // ✅ Permitir Arena aunque haya misión activa:
  const arenaDisabled = !hasEnoughEnergyForArena;

 const goArena = () => {
 if (arenaDisabled) return;
 navigate('/game/arena');   // o '/arena' según tu router
 };

  return (
    <Box
      sx={{
        minHeight: '100%',
        width: '100%',
        position: 'relative',
        backgroundImage:
          'url(https://res.cloudinary.com/dpwv380jp/image/upload/v1754942090/Blue_And_Black_Modern_YouTube_Shorts_Outro_Mobile_Video_1_rmzcny.gif)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        py: { xs: 2, md: 4 },
      }}
    >
      {/* Cronos */}
      {timeServer !== '' && informacion?.mision?.start && (
        <AppBar sx={{ position: 'relative', mb: 1 }}>
          <Toolbar disableGutters variant="dense" sx={{ background: 'rgba(255,255,255,0.1)', justifyContent: 'center' }}>
            <Cronometro tipo="normal" timeServer={timeServer} time={informacion?.mision?.Tiempo} />
          </Toolbar>
        </AppBar>
      )}

      {timeServer !== '' && informacion?.misionEspecial?.start && (
        <AppBar sx={{ position: 'relative', mb: 1 }}>
          <Toolbar disableGutters variant="dense" sx={{ background: 'rgba(255,165,0,0.8)', justifyContent: 'center' }}>
            <Typography sx={{ color: 'white', fontWeight: 'bold', mr: 1 }}>ESPECIAL:</Typography>
            <Cronometro tipo="especial" timeServer={timeServer} time={informacion?.misionEspecial?.Tiempo} />
          </Toolbar>
        </AppBar>
      )}

      {/* GRID sin “cuadrados”: todo alineado */}
      <MuiContainer maxWidth="lg">
        <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
          {/* BLOQUE helper (reutilizable) */}
          {[
            {
              key: 'isla1h',
              img: tierra1,
              infoLeft: `${informacion?.costos?.primera} - energy`,
              infoRight: `1 - ${Number(informacion?.poder ?? 0) + 80} HUESOS`,
              btn: { label: 'DIG 1 HOUR', onClick: () => mision(1), disabled: informacion?.mision?.start },
            },
            {
              key: 'recharge',
              img: tierra3,
              infoLeft: '',
              infoRight: `${(informacion?.poderEnergia ?? 0) + 2} energy`,
              btn: { label: 'RECHARGE', onClick: () => mision(3), disabled: informacion?.mision?.start, color: 'warning' },
            },
            {
              key: 'isla6h',
              img: tierra2,
              infoLeft: `${informacion?.costos?.segunda} - energy`,
              infoRight: `10 - ${Number(informacion?.poder ?? 0) * 5 + 400} HUESOS`,
              btn: { label: 'WALK 6 HOURS', onClick: () => mision(6), disabled: informacion?.mision?.start },
            },
            {
              key: 'pool',
              img: tierra4,
              infoLeft: '',
              infoRight: '',
              btn: { label: informacion?.packInicial ? 'POOL' : 'BUY ISLAND', onClick: () => (informacion?.packInicial ? handleOpen(3) : comprar()) },
            },
            {
              key: 'arena',
              img: 'https://res.cloudinary.com/druu0mcam/image/upload/v1719339315/swap-_3_rrlyrk_i8zkan.gif',
              infoLeft: `${ARENA_ENERGY_COST} energy`,
              infoRight: `Entry fee: ${ARENA_ENTRY_FEE} HUESO`,
              btn: { label: 'ENTER ARENA', onClick: goArena, disabled: !hasEnoughEnergyForArena },
              tooltip: !hasEnoughEnergyForArena
              ? `Not enough energy (${energiaActual}/${ARENA_ENERGY_COST})`
               : '',
           },
            {
              key: 'isla4h',
              img: tierra5,
              infoLeft: `${(informacion?.costos?.primera ?? 0) * 2 + 5} - energy`,
              infoRight: `1 - ${Number(informacion?.poder ?? 0) + 200} HUESOS`,
              btn: { label: 'DIG 4 HOURS', onClick: () => mision(4), disabled: informacion?.misionEspecial?.start, color: 'warning' },
            },
          ].map((b) => (
            <Grid key={b.key} item xs={12} sm={6} md={4} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  width: '100%',
                  minHeight: BLOCK_MIN_HEIGHT,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  px: { xs: 1, md: 2 },
                  // efecto hover sutil sin fondo/caja
                  transition: 'transform 160ms ease',
                  '&:hover': { transform: 'translateY(-4px)' },
                }}
              >
                {/* Imagen */}
                <CardMedia component="img" image={b.img} alt={b.key} sx={ISLAND_IMG_SX} />

                {/* Row info (energía / huesos) */}
                {(b.infoLeft || b.infoRight) && (
                  <Box sx={{ mt: 1, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: 'red', visibility: b.infoLeft ? 'visible' : 'hidden' }}>
                      {b.infoLeft || '—'}
                    </Typography>
                    <Typography sx={{ color: 'red', textAlign: 'right', flexShrink: 0 }}>
                      {b.infoRight}
                    </Typography>
                  </Box>
                )}

                {/* Spacer para alinear botones al mismo nivel visual */}
                <Box sx={{ flexGrow: 1 }} />

                {/* Botón (con tooltip opcional en Arena) */}
                {b.tooltip ? (
                  <Tooltip title={b.tooltip} arrow placement="top">
                    <span>
                      <Button fullWidth sx={{ mt: 1.5 }} onClick={b.btn.onClick} variant="contained" disabled={b.btn.disabled} color={b.btn.color || 'primary'}>
                        {b.btn.label}
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button fullWidth sx={{ mt: 1.5 }} onClick={b.btn.onClick} variant="contained" disabled={b.btn.disabled} color={b.btn.color || 'primary'}>
                    {b.btn.label}
                  </Button>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </MuiContainer>

{/* Banner inferior de mensajes */}
{control && mensaje?.texto && (
  <AppBar
    sx={{
      position: 'sticky',
      bottom: 0,
      height: '84px',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    }}
    position="static"
  >
    <Container maxWidth="xl">
      <Toolbar
        disableGutters
        sx={{
          display: 'flex',
          color: 'black',
          justifyContent: 'center',
          background: 'orange',
          alignItems: 'center',
          textAlign: 'center',
          px: 2,
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={{ fontSize: { xs: '0.9rem', md: '1.1rem' } }}>
          {mensaje.texto}
        </Typography>

        {/* Botón / enlace opcional */}
        {mensaje.linkUrl && (
          <Button
            component="a"
            href={mensaje.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="secondary"
            size="small"
            sx={{ ml: { xs: 0, md: 2 }, fontWeight: 'bold' }}
          >
            {mensaje.linkLabel || 'More info'}
          </Button>
        )}
      </Toolbar>
    </Container>
  </AppBar>
)}


      <ModalPool handleClose={handleClose} open={open} />

      {/* Snackbars */}
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar
          open={open2}
          autoHideDuration={9000}
          onClose={handleClose2}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          {error ? (
            <Alert onClose={handleClose2} severity="error" variant="filled" sx={{ width: '100%' }}>
              {errorText || 'Mission error'}
            </Alert>
          ) : (
            <Alert onClose={handleClose2} severity="success" variant="filled" sx={{ width: '100%' }}>
              {errorText || 'Success'}
            </Alert>
          )}
        </Snackbar>
      </Stack>

      {/* Modal Ecosystem */}
      <Modal open={open9} onClose={handleClose9} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className="bordes scroll scroll-small" sx={modalStyle}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h3">ECOSYSTEM</Typography>
            <Typography variant="h6">
              'Here you will find a list of projects created or where the creator and owner of the game king of duels "LAVINO" participates.'
            </Typography>
          </Box>
          <Hueso />
        </Box>
      </Modal>

      {/* Barras de logos (derecha) */}
      <VerticalLogosRight items={gameLogos}>
        <MetricsHuesoButton />
      </VerticalLogosRight>

      <VerticalLogosRight
        items={appsLogos}
        sx={{ top: 'auto', bottom: { xs: 24, sm: 32 }, right: { xs: 8, sm: 16 } }}
      />



<EntryOverlay
  open={showEntryOverlay}
  onClose={closeEntryOverlay}
  mediaSrc="https://res.cloudinary.com/dekoxefky/video/upload/v1761188757/Mi_video_1_pyhe4b.mp4"
  burnRoute={BURN_PATH}
  arenaRoute={ARENA_PATH}
  rankingRoute={RANKING_PATH}
/>



<PetOverlay />


    </Box>
  );
};
